/**
 * Tabular Layout Index
 * 
 * Exports the tabular layout configuration.
 */

import { TabularLayout } from './TabularLayout';
import { TabularOptions } from './TabularOptions';
import type { LayoutConfig, TabularLayoutOptions } from '../types';

export const tabularLayout: LayoutConfig<TabularLayoutOptions> = {
    id: 'tabular',
    name: 'Table',
    icon: 'table_rows',
    component: TabularLayout,
    optionsComponent: TabularOptions,
    headerShadow: false,
};

export { TabularLayout } from './TabularLayout';
export { TabularOptions } from './TabularOptions';
